import { useAuthContext } from "../auth-provider.js";
/**
 * Access the auth state populated by `<AuthProvider>`.
 *
 * @throws if called outside `<AuthProvider>`.
 */
export function useAuth() {
    return useAuthContext();
}
//# sourceMappingURL=use-auth.js.map